import React, { useState } from 'react';

import { ButtonV2, TooltipTrigger } from 'components';
import { Form } from 'components';

function SelectAuthenticator({ authenticators, onContinue }) {
  const [selectedAuthenticator, setSelectedAuthenticator] = useState(null);

  const onChange = formData => {
    setSelectedAuthenticator(authenticators.find(a => a.kind === formData.selectedKind));
  };

  const buttonLabel = selectedAuthenticator
    ? authenticators.find(a => a.kind === selectedAuthenticator.kind).buttonLabel
    : 'Select Method';

  const authenticatorOptions = authenticators
    .filter(a => !a.enabled)
    .map(authenticator => ({
      value: authenticator.kind,
      label: (
        <div className="mfa-add-method__mfa_options_label">
          <p>{authenticator.label}</p>
          {authenticator.tooltip && (
            <TooltipTrigger
              className="mfa-add-method__mfa_options_tooltip_trigger"
              tooltip={authenticator.tooltip}
              side="center"
              tooltipClassName="mfa-add-method__mfa_options_tooltip"
            >
              <ButtonV2 icon iconName="tooltip" iconSize="18" />
            </TooltipTrigger>
          )}
        </div>
      )
    }));

  return (
    <Form onChange={onChange}>
      <div className="modal__header mfa-add-method">
        <div className="modal__header-title">
          Add Verification Method{' '}
          <label>
            <strong>Step 1</strong> / 3
          </label>
        </div>
      </div>
      <div className="modal__container">
        <div className="mfa-add-method__description">
          Select an available multi-factor verification method below to add to your account.
        </div>
        <Form.RadioGroup
          className="mfa-add-method__verification-methods"
          name="selectedKind"
          type="circle"
          options={authenticatorOptions}
        />
      </div>
      <div className="modal__footer">
        <ButtonV2
          className="button--primary"
          label={buttonLabel}
          onClick={() => onContinue({ selectedAuthenticator })}
          disabled={!selectedAuthenticator}
        />
      </div>
    </Form>
  );
}

export default SelectAuthenticator;
